/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Vector2, Vector3, Vector4 } from 'three';
/**
 * Collection of math operations
 */
export class MathFunctions {
    static sigmoid(x) {
        return 1 / (1 + Math.exp(x));
    }
    static logit(x) {
        return Math.log(x / (1 - x));
    }
    static bell(x) {
        return Math.exp(Math.pow(x, 2.0));
    }
    static isAlmostEqual(n1, n2, epsilon) {
        if (epsilon === undefined) {
            epsilon = Number.EPSILON;
        }
        return Math.abs(n1 - n2) <= epsilon;
    }
    static isVectorEqual(v1, v2, epsilon) {
        const _v1 = v1;
        const _v2 = v2;
        return MathFunctions.isAlmostEqual(_v1.x, _v2.x, epsilon) &&
            MathFunctions.isAlmostEqual(_v1.y, _v2.y, epsilon) &&
            ((!_v1.z || !_v2.z) || MathFunctions.isAlmostEqual(_v1.z, _v2.z, epsilon)) &&
            ((!_v1.w || !_v2.w) || MathFunctions.isAlmostEqual(_v1.w, _v2.w, epsilon));
    }
    static isNumberArrayEqual(arr1, arr2, epsilon) {
        if (arr1.length !== arr2.length) {
            return false;
        }
        if (epsilon === undefined) {
            epsilon = Number.EPSILON;
        }
        for (let i = 0; i < arr1.length; i++) {
            if (Math.abs(arr1[i] - arr2[i]) > epsilon) {
                return false;
            }
        }
        return true;
    }
    static arrayToVector(arr) {
        switch (arr.length) {
            case 2: return new Vector2(...arr);
            case 3: return new Vector3(...arr);
            case 4: return new Vector4(...arr);
            default: throw new Error('Invalid array length');
        }
    }
}
//# sourceMappingURL=MathFunctions.js.map